import { render, staticRenderFns } from "./SelectMailSettings.vue?vue&type=template&id=73df8ea4"
import script from "./SelectMailSettings.vue?vue&type=script&lang=ts"
export * from "./SelectMailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73df8ea4')) {
      api.createRecord('73df8ea4', component.options)
    } else {
      api.reload('73df8ea4', component.options)
    }
    module.hot.accept("./SelectMailSettings.vue?vue&type=template&id=73df8ea4", function () {
      api.rerender('73df8ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/SelectMailSettings.vue"
export default component.exports